import { EntitySize, SizeEvaluation } from "../types";

export const evaluateEntitySize = (
  salariati: number,
  cifraAfaceri: number,
  active: number
): SizeEvaluation | null => {
  // Return null if no meaningful data provided
  if (salariati === 0 && cifraAfaceri === 0 && active === 0) {
    return null;
  }

  // Conform Legii 346/2004 și Regulamentului UE 651/2014

  // Criterii pentru fiecare dimensiune (trebuie îndeplinite SIMULTAN)
  const isMica =
    salariati < 50 && (cifraAfaceri <= 10000000 || active <= 10000000);
  const isMijlocie =
    salariati < 250 && (cifraAfaceri <= 50000000 || active <= 43000000);

  let size: EntitySize;
  let explanation: string;

  if (isMica) {
    size = "MICĂ";
    explanation =
      "Entitate cu mai puțin de 50 angajați și cifra de afaceri sau active totale sub 10 mil EUR";
  } else if (isMijlocie) {
    size = "MIJLOCIE";
    explanation =
      "Entitate cu mai puțin de 250 angajați și cifra de afaceri sub 50 mil EUR sau active sub 43 mil EUR";
  } else {
    size = "MARE";
    explanation =
      "Entitate cu 250 sau mai mulți angajați sau cifra de afaceri peste 50 mil EUR sau active peste 43 mil EUR";
  }

  return {
    size,
    criteria: {
      salariati:
        size === "MARE"
          ? salariati >= 250
          : size === "MIJLOCIE"
            ? salariati < 250
            : salariati < 50,
      cifraAfaceri:
        size === "MARE"
          ? cifraAfaceri > 50000000
          : size === "MIJLOCIE"
            ? cifraAfaceri <= 50000000
            : cifraAfaceri <= 10000000,
      active:
        size === "MARE"
          ? active > 43000000
          : size === "MIJLOCIE"
            ? active <= 43000000
            : active <= 10000000,
    },
    explanation,
  };
};
